import { get } from 'lodash'
import { useContext } from 'react'

import Topbar from 'components/Topbar/Topbar.index'
import { TopbarProps } from 'components/Topbar/Topbar.types'
import { AssetsContext } from 'providers/Assets'
import { PagesContext } from 'providers/Pages'

export const useTopbarData = (): TopbarProps => {
  const assetsState = useContext(AssetsContext)
  const pagesState = useContext(PagesContext)
  const logos = get(assetsState, 'assets.logos', [])
  const banners = get(assetsState, 'assets.banners', [])
  const topbarProps = get(assetsState, 'assets.topbar')
  const mobileProps = get(topbarProps, 'topbarMobile', {})
  const desktopProps = get(topbarProps, 'topbarDesktop', {})
  const menuTopItems = get(pagesState, 'navigation.menuTop', [])
  
  return {
    topbarMobile: { ...mobileProps, menuTopItems, logos, banners },
    topbarDesktop: { ...desktopProps, menuTopItems, logos, banners }
  }
}

const RenderTopbar = () => {
  return <Topbar {...useTopbarData()} />
}

export default RenderTopbar